/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrgCountByFilter } from './orgCountByFilter';


export interface OrgCountSummary { 
    org_count_by_activation_state?: Array<OrgCountByFilter>;
    org_count_by_aws_region?: Array<OrgCountByFilter>;
    org_count_by_cb_pop?: Array<OrgCountByFilter>;
    /**
     * Count of orgs in Ransomware Recovery Deployments
     */
    total_org_count?: number;
}

